import { render, staticRenderFns } from "./URLManager.vue?vue&type=template&id=ab6682f2"
import script from "./URLManager.vue?vue&type=script&lang=js"
export * from "./URLManager.vue?vue&type=script&lang=js"
import style0 from "./URLManager.vue?vue&type=style&index=0&id=ab6682f2&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports